import React from 'react';

// Custom emoji-based icon components
export const AlertCircle = ({ className }: { className?: string }) => (
  <span className={className}>⚠️</span>
);

export const FileText = ({ className }: { className?: string }) => (
  <span className={className}>📄</span>
);

export const Shield = ({ className }: { className?: string }) => (
  <span className={className}>🛡️</span>
);

export const TrendingUp = ({ className }: { className?: string }) => (
  <span className={className}>📈</span>
);

export const Calendar = ({ className }: { className?: string }) => (
  <span className={className}>📅</span>
);

export const Settings = ({ className }: { className?: string }) => (
  <span className={className}>⚙️</span>
);

export const Download = ({ className }: { className?: string }) => (
  <span className={className}>⬇️</span>
);

export const RefreshCw = ({ className }: { className?: string }) => (
  <span className={className}>🔄</span>
);

export const Plus = ({ className }: { className?: string }) => (
  <span className={className}>➕</span>
);

export const Search = ({ className }: { className?: string }) => (
  <span className={className}>🔍</span>
);

export const Filter = ({ className }: { className?: string }) => (
  <span className={className}>🔽</span>
);

export const Upload = ({ className }: { className?: string }) => (
  <span className={className}>⬆️</span>
);

export const AlertTriangle = ({ className }: { className?: string }) => (
  <span className={className}>⚠️</span>
);

export const CheckCircle = ({ className }: { className?: string }) => (
  <span className={className}>✅</span>
);

export const Clock = ({ className }: { className?: string }) => (
  <span className={className}>🕐</span>
);

export const Check = ({ className }: { className?: string }) => (
  <span className={className}>✓</span>
);

export const ChevronDown = ({ className }: { className?: string }) => (
  <span className={className}>▼</span>
);

export const ChevronUp = ({ className }: { className?: string }) => (
  <span className={className}>▲</span>
);

export const Eye = ({ className }: { className?: string }) => (
  <span className={className}>👁️</span>
);

export const EyeOff = ({ className }: { className?: string }) => (
  <span className={className}>🙈</span>
);

export const Copy = ({ className }: { className?: string }) => (
  <span className={className}>📋</span>
);

export const Edit = ({ className }: { className?: string }) => (
  <span className={className}>✏️</span>
);

export const Key = ({ className }: { className?: string }) => (
  <span className={className}>🔑</span>
);